import React, { Component } from "react";
import PropTypes from "prop-types";
// import logo from "../../assets/logo_25.png";

import { Link } from "react-router-dom";
import styles from "../Footer/Footer.module.scss";
export class Footer extends Component {
  static propTypes = {};

  render() {
    return (
      <div>
        <footer className={styles.footer}>
          <div className="container">
            <div className={styles.footer_wraps}>
              <div className={styles.wrap}>
                <img src="assets/logo_25.png" alt="" />
                <p>Feel like Home , Business from Home</p>
                <ul className={styles.icon}>
                  <li>
                    <Link href="">
                      <i className="fa fa-twitter"></i>
                    </Link>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      className={styles.fb}
                      to="https://www.facebook.com/profile.php?id=100063792404065"
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://www.instagram.com/p/ClBf_VfvEuP/?igshid=YmMyMTA2M2Y%3D"
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>

              <div className={styles.wrap}>
                <h1>Contact Information</h1>

                <p>
                  Tirath Mansion, 5, Mahatma Gandhi <br />
                  Main Rd, Ranchi, Jharkhand 834001
                </p>
                <p>+91 - 94311 09245</p>
                <p>omranjan@hotelpalashresidency.com</p>
                <p>info@hotelpalashresidency.com</p>
              </div>
              <div className={styles.wrap}>
                <h1>Newsletter</h1>
                <p>Far far away from home , a homely abode</p>
              </div>
            </div>
            <div className={styles.footer_bottom}>
              <p>
                Copyright ©
                <script>document.write(new Date().getFullYear());</script>
                2022 All rights reserved Hotel Palash Residency
              </p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default Footer;
